module.exports = __webpack_public_path__ + "static/img/servicios_foto2.155d035.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/servicios_foto2.png
// module id = 99
// module chunks = 0